module.exports = __webpack_public_path__ + "media/images/img-travel-8-bcd85b1b.jpg";